import { type EnvironmentId, type ThreadId } from "@t3tools/contracts";
import { BotIcon } from "lucide-react";
import { scopeThreadRef } from "@t3tools/client-runtime";

import { t } from "~/i18n";
import { Button } from "../ui/button";
import { openSubAgentList } from "../../subAgentPanelStore";

export function SubAgentsHeaderButton({
  environmentId,
  threadId,
}: {
  environmentId: EnvironmentId;
  threadId: ThreadId;
}) {
  return (
    <Button
      variant="outline"
      size="xs"
      className="shrink-0 gap-1"
      onClick={() => openSubAgentList(scopeThreadRef(environmentId, threadId))}
    >
      <BotIcon className="size-3" />
      {t("chat/agents_5abvl7")}
    </Button>
  );
}
